import styled from 'styled-components';

export const PlanLabelWrapper = styled.div`
  display: block;
  font-size: 12px;
  line-height: 13px;
  color: rgb(252, 80, 133);
  text-transform: uppercase;
`;
